import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CharacterPage from "@/pages/character/page";
import CharactersPage from "@/pages/characters/page";
import FlavorPage from "@/pages/flavor/page";
import StoriesPage from "@/pages/stories/page";
import StoryPage from "@/pages/story/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/character/:id",
    element: <CharacterPage />,
  },
  {
    path: "/characters",
    element: <CharactersPage />,
  },
  {
    path: "/flavor/:id",
    element: <FlavorPage />,
  },
  {
    path: "/stories",
    element: <StoriesPage />,
  },
  {
    path: "/stories/:id",
    element: <StoryPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;